import { Control, Controller } from "react-hook-form";

import Input from "@/components/Atoms/InputsV2/SelectInput";
import ErrorUI from "@/components/Atoms/InputsV2/ErrorUI";

import { classNameGenerator } from "@/utils";

import styles from "./SelectInput.module.scss";

interface SelectInputProps {
  name: string;
  control: Control<any>;
  placeholder?: string;
  className?: string;
  onBlur?: (e: any) => void;
  options: any;
}

const SelectInput: React.FC<SelectInputProps> = ({
  name,
  control,
  placeholder = "Select a value",
  onBlur = () => {},
  ...rest
}) => {
  const cls = classNameGenerator(styles);

  return (
    <div className={cls("selectInput")}>
      <Controller
        name={name}
        control={control}
        shouldUnregister
        render={({
          field: { value, onBlur: handleBlur, onChange, ref },
          fieldState: { error },
        }) => (
          <>
            <Input
              ref={ref}
              name={name}
              value={value}
              onChange={onChange}
              onBlur={(e) => {
                handleBlur();
                onBlur(e);
              }}
              placeholder={placeholder}
              {...rest}
            />
            <ErrorUI error={error?.message} />
          </>
        )}
      />
    </div>
  );
};

export default SelectInput;
